import { ieee, mla, mla7, mla8 } from './styleConstants'

export const effortlesslyTextList = [
  ['ieee-asme-transactions-on-mechatronics', 'website'],
  ['ieee-transactions-on-industrial-electronics', 'book'],
  ['ieee-with-url', 'website'],
  [ieee, 'bible'],
  [ieee, 'blog'],
  [ieee, 'dissertation'],
  [ieee, 'digital image'],
  [ieee, 'lecture'],
  [ieee, 'microform'],
  [ieee, 'pamphlet'],
  [ieee, 'photos'],
  [ieee, 'website'],
  [mla8, 'advertisement'],
  [mla8, 'book'],
  [mla8, 'database'],
  [mla8, 'dissertation'],
  [mla8, 'editorial'],
  [mla8, 'encyclopedia'],
  [mla8, 'film/online video'],
  [mla8, 'digital image'],
  [mla8, 'introduction'],
  [mla8, 'magazines'],
  [mla8, 'microform'],
  [mla8, 'miscellaneous'],
  [mla8, 'review'],
  [mla8, 'website'],
  [mla, 'bible'],
  [mla, 'dissertation'],
  [mla, 'film/online video'],
  [mla, 'newspaper'],
  [mla, 'report'],
  [mla7, 'chapter'],
  [mla7, 'encyclopedia'],
  [mla7, 'interview'],
  [mla7, 'lecture'],
  [mla7, 'miscellaneous'],
  [mla7, 'music'],
  [mla7, 'photos'],
  [mla7, 'review'],
  [mla7, 'tv/radio'],
]

export const effortlesslyTextDesc = (style: string, source: string): string => {
  return `Effortlessly cite ${source} in ${style} format with Citation genrator. Hassle-free citations for your academic or professional needs. Streamline your research process!`
}
